import React from 'react'
import './index.scss'

export default ({ children }) => (
  <div className="submit-row">
    {children}
  </div>
)



// WEBPACK FOOTER //
// ./src/elements/submit-row/index.js